import { ThemeProvider, OeDefaultTheme } from '@openeducation/oe-rn-themes';
import {
  LessonPlayerConfig,
  LessonPlayerProvider,
  StudentInfo,
} from '@openeducation/react-native-lesson-player';
import React, { useCallback, useState } from 'react';
import { StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { fonts, useFontsLoader } from '../../hooks/useFontsLoader';
import { useStudentInfo } from '../../hooks/useStudentInfo';
import { getUrlParams } from '../../utils/get-url-params';
import { Lesson } from '../lesson/lesson';

export const LessonScreen = () => {
  const params = getUrlParams();

  const { fontsLoaded } = useFontsLoader();
  const [lessonPlayerConfig, setLessonPlayerConfig] = useState<LessonPlayerConfig>({
    isTranslationButtonEnabled: !!params.isTranslationButtonEnabled,
    showTranslationButton: !!params.showTranslationButton,
    preferredLang: params.language,
    environment: params.environment,
    areSoundEffectsEnabled: params.areSoundEffectsEnabled !== false,
    centrosModeEnabled: false,
    referralMessageElligible: params.referralMessageElligible,
    referralBonusAmount: decodeURI(params.referralBonusAmount),
  });

  const updateStudentInfo = useCallback(
    (studentInfo: StudentInfo) => {
      setLessonPlayerConfig({
        ...lessonPlayerConfig,
        studentInfo,
      });
    },
    [lessonPlayerConfig]
  );

  useStudentInfo(updateStudentInfo);

  if (!fontsLoaded) {
    return null;
  }

  return (
    <SafeAreaView style={styles.container} edges={['top']}>
      <LessonPlayerProvider fonts={fonts} config={lessonPlayerConfig}>
        <ThemeProvider theme={OeDefaultTheme}>
          <Lesson />
        </ThemeProvider>
      </LessonPlayerProvider>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'hidden',
  },
});
